<template>
  <div v-if="isShow" :style="{ width: formWidth(form.input_position) }">
    <Field
      v-slot="{ value, field, handleChange, errorMessage, meta }"
      :name="`itemId${form.id}`"
      :type="form.input_type"
      :validateOnMount="true"
      :validateOnInput="true"
    >
      <BaseTextInput
        v-if="form.input_type === 'text'"
        :name="`itemId${form.id}`"
        :label="form.input_question"
        :note="form.input_note"
        :required="isRequired"
        :placeholder="form.input_example"
        :field="field"
        :error-message="errorMessage && meta.dirty ? errorMessage : ''"
        :on-change="handleChange"
        class="mb-6"
      />

      <BaseSelectbox
        v-if="form.input_type === 'select'"
        :name="`itemId${form.id}`"
        :label="form.input_question"
        :note="form.input_note"
        :required="isRequired"
        :value="value"
        :option-format-type="form.display_format_type"
        :unit="form.unit"
        :options="form.options"
        :field="field"
        :error-message="errorMessage && meta.dirty ? errorMessage : ''"
        :on-change="handleChange"
        class="mb-6"
      />

      <BaseTextarea
        v-if="form.input_type === 'textarea'"
        :name="`itemId${form.id}`"
        :label="form.input_question"
        :note="form.input_note"
        :required="isRequired"
        :field="field"
        :error-message="errorMessage && meta.dirty ? errorMessage : ''"
        :on-change="handleChange"
      />

      <BaseDate
        v-if="form.input_type === 'date'"
        :name="`itemId${form.id}`"
        :label="form.input_question"
        :note="form.input_note"
        :required="isRequired"
        :field="field"
        :error-message="errorMessage && meta.dirty ? errorMessage : ''"
        :on-change="handleChange"
      />
    </Field>

    <RegistrationFormCheckbox
      v-if="form.input_type === 'checkbox'"
      :name="`itemId${form.id}`"
      :label="form.input_question"
      :note="form.input_note"
      :required="isRequired"
      :option-format-type="form.display_format_type"
      :unit="form.unit"
      :disabled="form.input_disabled"
      :options="form.options"
      @selectAll="selectAll"
      class="mb-6"
    />

    <RegistrationFormRadio
      v-if="form.input_type === 'radio'"
      :name="`itemId${form.id}`"
      :label="form.input_question"
      :note="form.input_note"
      :required="isRequired"
      :option-format-type="form.display_format_type"
      :unit="form.unit"
      :disabled="form.input_disabled"
      :options="form.options"
      class="mb-6"
    />
  </div>
</template>

<script>
import { reactive, computed, toRefs } from 'vue';
import { Field } from 'vee-validate';

import { amountFormatter } from '@/utils/filters.js';
import BaseTextInput from '@/components/form/BaseTextInput.vue';
import BaseSelectbox from '@/components/form/BaseSelectbox.vue';
import BaseTextarea from '@/components/form/BaseTextarea.vue';
import BaseDate from '@/components/form/BaseDate.vue';
import RegistrationFormCheckbox from './RegistrationFormCheckbox.vue';
import RegistrationFormRadio from './RegistrationFormRadio.vue';

export default {
  components: {
    Field,
    BaseTextInput,
    BaseSelectbox,
    BaseTextarea,
    BaseDate,
    RegistrationFormCheckbox,
    RegistrationFormRadio,
  },
  props: {
    inputValue: Object,
    form: Object,
    formData: Object,
    errors: Object,
    isDirty: Object,
    hiddenItems: Object,
  },
  emits: ['select-all'],
  setup(props, { emit }) {
    const state = reactive({
      isRequired: computed(() => {
        if (
          !Object.keys(props.form).length ||
          !props.form.input_validation_rule
        ) {
          return false;
        }
        return props.form.input_validation_rule.indexOf('required') >= 0;
      }),
      formWidth: computed(() => (position) => {
        const halfWidth = position === 'left' || position === 'right';
        return halfWidth ? 'calc(50% - 20px)' : '100%';
      }),
      isShow: computed(() => {
        if (!Object.keys(props.form).length || !props.hiddenItems) return true;
        return (
          props.hiddenItems[props.form.id] === undefined ||
          props.hiddenItems[props.form.id] === true
        );
      }),
    });

    const selectAll = ({ name, value }) => {
      emit('select-all', { name, value });
    };

    return {
      ...toRefs(state),
      amountFormatter,
      selectAll,
    };
  },
};
</script>

<style lang="scss" scoped></style>
